const gsap = window.gsap
const SplitText = window.SplitText
const ScrollTrigger = window.ScrollTrigger

if (typeof window !== 'undefined') {
  const pluginsToRegister = [SplitText, ScrollTrigger].filter(Boolean)

  gsap.registerPlugin(...pluginsToRegister)

  gsap.config({
    autoSleep: 60,
    force3D: true,
    nullTargetWarn: false
  })

  gsap.defaults({ ease: 'none' })
  gsap.ticker.lagSmoothing(0)
}

if (typeof window !== 'undefined' && ScrollTrigger) {
  ScrollTrigger.clearScrollMemory('manual')
  ScrollTrigger.defaults({
    markers: false
  })
}
